import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpClientBase } from './http-client-base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoteService extends HttpClientBase {
  constructor(http: HttpClient) {
    super(http, 'lotes'); // La URL base para el servicio de lotes
  }

  getLotes(
    page: number,
    limit: number,
    id_usuario: string = '',
    estado_short_name: string = '',
    titulo: string = '',
    id: string = ''
  ) {

    let params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('pagination', 'true');

    if (id_usuario) {
      params = params.set('id_usuario', id_usuario);
    }

    if (estado_short_name) {
      params = params.set('estado_short_name', estado_short_name);
    }

    if (titulo) {
      params = params.set('titulo', titulo);
    }

    if (titulo) {
      params = params.set('titulo', titulo);
    }

    if (id) {
      params = params.set('id', id);
    }

    return this.get<any[]>({
      endpoint: '',
      params,
      trackLoading: true
    });
  }


  getResumenFirma(id_lote: number, params: any): Observable<any> {        
        return this.get<any>({ endpoint: `${id_lote}/grupos/resumenes`, params });
  }

  addScratch(loteId: number, body: any): Observable<any> {
    return this.post<any>(
      body,
      `/${loteId}/firmantes/cache`,
      undefined,
      true // 👈 loader
    );
  }

  
  crearReintento(loteId: number, body: any): Observable<any> {
    return this.post<any>(
      body,
      `/${loteId}/firmas/electronicas/masivas/reintentar`,
      undefined,
      true // 👈 loader
    );
  }

  updLote(body: any, idLote: number): Observable<any> {
    return this.put<any>(body, `${idLote}`, undefined, true); // 👈 loader
  }

  firmaElectronicaSimple(loteId: number, body: any): Observable<any>{
    return this.post<any>(
      body,
      `/${loteId}/firmas/electronicas/simples`,
      undefined,
      true // 👈 loader
    );
  }

  restaurarFirmaMasiva(loteId: number, body: any): Observable<any>{
    return this.post<any>(
      body,
      `/${loteId}/firmas/electronicas/masivas/restaurar`,
      undefined,
      true // 👈 loader
    );
  }

  cambioEstado(loteId: number, body: any): Observable<any> {
    return this.put<any>(
      body,
      `${loteId}/estados`,
      undefined,
      true // 👈 loader
    );
  }
  
  addCertificadoCoordenadaPlantilla(body: any, loteId: number) {
    return this.post<any>(
      body,
      `${loteId}/coordenadas`,
      undefined,
      true // 👈 loader
    );
  }

  deleteCoordenadaGrupo(idLote: number, params: any) {
    return this.delete<any>(`${idLote}/detalles/urls/coordenadas/grupos`, params);
  }

  loteDetalleGrupo(id_lote: number, params: any): Observable<any> {        
        return this.get<any>({ endpoint: `${id_lote}/detalles`, params });
  }

  deleteLote(loteId: number){
    return this.delete<any>(`${loteId}`);
  }

  getUsuariosLote(  idLote: any , list:any , params: any ){
    return this.get<any>({ endpoint: `${idLote}/certificados/${list}/grupos`, params });
  }

  
  getPorFirmar(page, limit , params:any = {}): Observable<any> {        
        return this.get<any>({ endpoint: `detalles/urls/coordenadas/pendientes?page=${page}&limit=${limit}&pagination=true`, params });
  }

  getLotesReintentos(params: { estado_short_name?: string } = {}) {
    let httpParams = new HttpParams();

    if (params.estado_short_name !== undefined && params.estado_short_name !== null) {
      httpParams = httpParams.set('estado_short_name', String(params.estado_short_name));
    }

    return this.get<any[]>({
      endpoint: 'reintentos/pendientes',
      params: httpParams,
      trackLoading: true,
    });
  }

  getReintentosDetalleByLote(
    loteId: number,
    page: number,
    limit: number,
    estado_short_name = 'FAL', // o lo que uses
  ) {
    const params = new HttpParams()
      .set('page', String(page))
      .set('limit', String(limit))
      .set('pagination', 'true')
      .set('estado_short_name', estado_short_name);

    return this.get<any>({
      endpoint: `${loteId}/reintentos/pendientes/detalle`,
      params,
      trackLoading: true,
    });
  }

  
  retransmitirServicioExterno(loteId: number): Observable<any> {
    return this.post<any>(
      {},
      `/${loteId}/externos/retransmitir`,
      undefined,
      true // 👈 loader
    );
  }

  crearConfiguracionLote(loteId: number, payload: any): Observable<any> {
    return this.post<any>(payload, `/${loteId}/configuraciones`, undefined, true);
  }

  

  showConfiguracionLote(loteId: any  ){
    return this.get<any>({ endpoint: `/${loteId}/configuraciones`});
  }

}
